export class EnterpriseUserNotificationCategoryRecipient {
	public id: number;
	public enterpriseId: number;
	public userNotificationCategoryId: number;
	public recipientUserId: string;
}
